import { ISummary } from 'interface/map'
import { ObjectKeys} from 'interface'
import { Route, Home, Vehicle, Mile, Service, Energy } from 'icons'
import { minutesToHHMM } from 'utils/minutesToHHMM'

const Stats = ({ items }: { items: ISummary }) => {
  const keys: ObjectKeys = {
    'total_routes': 'Routes',
    'total_appointments': 'Homes',
    'total_drive_miles': 'Miles',
    'total_drive_time_minutes': 'Drive',
    'total_service_time_minutes': 'Service',
    'appointments_per_gallon': 'Appts/Gal'
  }

  const calculateDiff = (type: string, plan: number, actual: number) => {
    let diff: string = ''

    diff = (Math.round(actual * 100 - plan * 100) / 100).toString()
    
    if (type === 'Drive' || type === 'Service') {
      diff = `${Number(diff) > 0 ? '' : '-'}${minutesToHHMM(Math.abs(Number(diff)))}`
    }

    let positive: boolean = false

    if (type === 'Drive' || type === 'Miles' || type === 'Service') {
      if (diff.charAt(0) === '-') {
        positive = true
      } else {
        diff = `+${diff}`
      }
    } else {
      if (diff.charAt(0) !== '-') {
        positive = true
        diff = `+${diff}`
      }
    }

    if (plan === actual)
      return (
        <div className="bg-[#F9FAFB] rounded p-4 text-right">
          <span className="text-black font-inter font-bold text-[15px] leading-5">---</span>
        </div>
      )
    else
      return (
        <div className={(positive ? 'bg-[#78C985]' : 'bg-[#F05252]') + ' rounded p-4 text-right'}>
          <span className="text-white font-inter font-bold text-[15px] leading-5">{diff}</span>
        </div>
      )
  }

  return (
    <div className="h-[calc(100%-40px)] overflow-auto flex flex-col gap-2 px-[5.5px] w-[343px] rounded">
      <div className="flex items-center justify-between">
        <div className="w-[60px]"></div>
        {['plan', 'actual', 'diff'].map((key) => (
          <div className="w-[80px] text-center" key={key}>
            <span className="text-[#4B5563] font-inter text-[12px] leading-4">{key.charAt(0).toUpperCase() + key.slice(1)}</span>
          </div>
        ))}
      </div>
      {items && Object.keys(keys).map((key: string, index: number) => (
        <div className="flex items-center justify-between" key={key} data-testid={`item_${index}`}>
          <div className="flex flex-col items-center gap-1 w-[60px]">
            {keys[key] === 'Routes' && <Route />}
            {keys[key] === 'Homes' && <Home />}
            {keys[key] === 'Miles' && <Mile />}
            {keys[key] === 'Drive' && <Vehicle />}
            {keys[key] === 'Service' && <Service />}
            {keys[key] === 'Appts/Gal' && <Energy />}
            <span className="text-[#9CA3AF] font-inter font-bold text-xs leading-[14px]">{ keys[key] }</span>
          </div>
          <div className="w-[80px]">
            <span className="bg-[#F9FAFB] block text-right text-[#4B5563] font-inter font-bold text-[15px] leading-5 p-4 rounded">
              { ['Drive', 'Service'].includes(keys[key]) ? minutesToHHMM(items[key]) : items[key] }
            </span>
          </div>
          <div className="w-[80px]">
            <span className="bg-[#F9FAFB] block text-right text-[#4B5563] font-inter font-bold text-[15px] leading-5 p-4 rounded">
              { ['Drive', 'Service'].includes(keys[key]) ? minutesToHHMM(items[`${key}_actual`]) : items[`${key}_actual`] }
            </span>
          </div>
          <div className="w-[80px]">
            {calculateDiff(keys[key], items[key], items[`${key}_actual`])}
          </div>
        </div>
      ))}
    </div>
  )
}

export default Stats
